//To Do: these icons must be replaced with Phosphor icons or relevant SVGs depends on which approach we use in future.
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react'
import Link from 'next/link'
import * as React from 'react'

import { cn } from '@/lib/utils'

const Pagination = ({ className, ...props }: React.ComponentProps<'nav'>) => (
  <nav role="navigation" aria-label="pagination" className={cn('mx-auto flex w-full justify-center', className)} {...props} />
)
Pagination.displayName = 'Pagination'

const PaginationContent = React.forwardRef<HTMLUListElement, React.ComponentProps<'ul'>>(({ className, ...props }, ref) => (
  <ul ref={ref} className={cn('flex flex-row items-center gap-1 sm:gap-2', className)} {...props} />
))
PaginationContent.displayName = 'PaginationContent'

const PaginationItem = React.forwardRef<HTMLLIElement, React.ComponentProps<'li'>>(({ className, ...props }, ref) => <li ref={ref} className={cn('', className)} {...props} />)
PaginationItem.displayName = 'PaginationItem'

type PaginationLinkProps = {
  isActive?: boolean
} & React.ComponentProps<typeof Link>

const PaginationLink = ({ className, isActive, ...props }: PaginationLinkProps) => (
  <Link
    aria-current={isActive ? 'page' : undefined}
    className={cn(
      'flex size-10 items-center justify-center rounded-full sm:size-12',
      isActive ? 'bg-primary-500 text-white' : 'border border-grey-200 bg-white text-grey-700 hover:border-grey-300',
      className,
    )}
    {...props}
  />
)
PaginationLink.displayName = 'PaginationLink'

const PaginationPrevious = ({ className, ...props }: React.ComponentProps<typeof PaginationLink>) => (
  <PaginationLink
    aria-label="Go to previous page"
    className={cn('flex size-10 items-center justify-center rounded-full border border-grey-200 bg-white hover:border-grey-300 sm:size-12', className)}
    {...props}
  >
    <CaretLeftIcon weight="bold" size={16} />
  </PaginationLink>
)
PaginationPrevious.displayName = 'PaginationPrevious'

const PaginationNext = ({ className, ...props }: React.ComponentProps<typeof PaginationLink>) => (
  <PaginationLink
    aria-label="Go to next page"
    className={cn('flex size-10 items-center justify-center rounded-full border border-grey-200 bg-white hover:border-grey-300 sm:size-12', className)}
    {...props}
  >
    <CaretRightIcon weight="bold" size={16} />
  </PaginationLink>
)
PaginationNext.displayName = 'PaginationNext'

const PaginationEllipsis = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span aria-hidden className={cn('flex size-10 items-center justify-center rounded-full border border-grey-200 bg-white text-grey-700 sm:size-12', className)} {...props}>
    <span>...</span>
    <span className="sr-only">More pages</span>
  </span>
)
PaginationEllipsis.displayName = 'PaginationEllipsis'

export { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious }
